import React from "react";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";

const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== "bordered",
})(({ theme, bordered }) => ({
  td: {
    ...theme.typography.tableCell,
    backgroundColor: theme.palette.background.default,
    ...(!bordered && { border: 0 }),
  },
  th: {
    ...theme.typography.tableHeader,
    backgroundColor: theme.palette.background.default,
    ...(!bordered && { border: 0 }),
  },
}));

const StyledTableContainer = styled(TableContainer, {
  shouldForwardProp: (prop) => prop !== "bordered",
})(({ theme, height, bordered }) => ({
  ...(bordered && {
    border: `1px solid ${theme.palette.grey200.main}`,
    borderRadius: 4,
  }),
  ...(height && {
    maxHeight: height,
    "& MuiTable-root": {
      height: "max-content",
    },
  }),
}));

const NarrowTable = ({
  items,
  columns = [],
  hideHeader = false,
  height,
  bordered = false,
  size = "small",
}) => {
  return (
    <StyledTableContainer height={height} bordered={bordered}>
      <Table size="small">
        {!hideHeader && (
          <TableHead>
            <StyledTableRow bordered={bordered}>
              {columns.map((c) => (
                <TableCell key={c.label}>{c.label}</TableCell>
              ))}
            </StyledTableRow>
          </TableHead>
        )}
        <TableBody>
          {items.map((row, index) => (
            <StyledTableRow
              bordered={bordered}
              key={`narrow-table-row-${index}-${row[columns[0].name]}`}
            >
              {columns.map((c, i) => (
                <TableCell
                  size={size}
                  key={`narrow-table-row-cell-${i}`}
                  scope="row"
                >
                  {row[c.name]}
                </TableCell>
              ))}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};

NarrowTable.propTypes = {
  items: PropTypes.array,
  columns: PropTypes.array,
  hideHeader: PropTypes.bool,
  height: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.func,
  ]),
  bordered: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium"]),
};

export default NarrowTable;
